/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Delta_CategoriesInputs */

const en_directory_launch_delta_categories = /** @type {(inputs: Directory_Launch_Delta_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8% vs last month`)
};

const zh_directory_launch_delta_categories = /** @type {(inputs: Directory_Launch_Delta_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较上月 +8%`)
};

/**
* | output |
* | --- |
* | "8% vs last month" |
*
* @param {Directory_Launch_Delta_CategoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_delta_categories = /** @type {((inputs?: Directory_Launch_Delta_CategoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Delta_CategoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_delta_categories(inputs)
	return zh_directory_launch_delta_categories(inputs)
});
export { directory_launch_delta_categories as "directory.launch.delta_categories" }